import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('multi-level-navigation-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentSublist: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        openSublist(e) {
            this.currentSublist = e.currentTarget.dataset.id;
            if (screen.width < 768 || screen.height < 600) {
                gsap.to('.search-icon-holder', 0.3, {
                    alpha: 0,
                    zIndex: 1,
                    ease: 'expo.easeOut'
                });
                gsap.to('.multi-level-nav__link-back', 0.3, {
                    alpha: 1,
                    zIndex: 2,
                    ease: 'expo.easeOut'
                });
                gsap.to('.multi-level-nav__list', 1, { x: '-100%', ease: "expo.easeOut" });
                gsap.to('.multi-level-nav__sublist-holder', 1, { x: '-100%', ease: "expo.easeOut", onComplete: this.addSublistClass });
            } else {
                gsap.to('.multi-level-nav__sublist-holder', 1, { onComplete: this.addSublistClass });
            }

        },

        closeSublist() {
            this.currentSublist = null;
            gsap.to('.multi-level-nav__link-back', 0.3, {
                alpha: 0,
                zIndex: 1,
                ease: 'expo.easeOut'
            });
            gsap.to('.search-icon-holder', 0.3, {
                alpha: 1,
                zIndex: 2,
                ease: 'expo.easeOut'
            });
            gsap.to('.multi-level-nav__list', 1, { x: '0%', ease: "expo.easeOut" });
            gsap.to('.multi-level-nav__sublist-holder', 1, { x: '0%', ease: "expo.easeOut" });
        },

        addSublistClass() {
            document.querySelector('.multi-level-nav__sublist.show').classList.add('active');
        }
    },
});
